// extracted by mini-css-extract-plugin
export var alertbanner = "AlertBanner-module--alertbanner--aa25f";
export var hidden = "AlertBanner-module--hidden--b10b0";
export var whiteBackground = "AlertBanner-module--whiteBackground--a445b";